import {_INPUT_RULES as REGEX_DEFAULT_INPUTS} from '../configuration/index.config';

// find all possible  key in inputRules.config - REGEX_DEFAULT_INPUTS
interface IExtraData{
    key?:string
}

class TextInputValidation {

    /**
     * checkIfEmpty - check if value is empty
     * @param value - value for check
     * @param min - min value
     */
    checkIfEmpty(value: string, min = 0) {
        return value.length === min;
    }

    /**
     * checkIfTooLarge - check if value is too large
     * @param value - value for check
     * @param max - the max length enable
     */
    checkIfTooLarge(value:string, max:number) {
        return value.length > max;
    }

    /**
     * checkValidValueRegex - check if value is valid by regex
     * @param value - value for check
     * @param key - the key in 'REGEX_DEFAULT_INPUTS' list
     */
    checkValidValueRegex(value:string, key:string) {
        if (this.checkIfEmpty(value)) {
            return true;
        }

        return value.match(REGEX_DEFAULT_INPUTS[key]);
    }

    /**
     * filterValue - clear value from special characters and spaces
     * @param value - the value that need to be clean
     */
    filterValue(value:string) {
        return value.replace(REGEX_DEFAULT_INPUTS.META_NAME_REMOVE, '').replace(/ /g, '_').toLowerCase();
    }

    /**
     * runValidationWithRegex - check validation on regex rules
     * @param value  - value for check
     * @param isCheckValue - if need to check isEmpty
     * @param extraData - if extra data needed
     */
    runValidationWithRegex(value:string, isCheckValue:boolean, extraData:IExtraData) {
        if (!extraData.key) {
            throw new Error('Didn\'t send a key!');
        }

        const isEmpty = isCheckValue ? this.checkIfEmpty(value) : false;

        return !isEmpty && this.checkValidValueRegex(value, extraData.key);
    }

    /**
     * runValidation - the main validation function
     * @param value - value for check
     * @param extraData - if extra data needed
     * @param isCheckValue - if need to check isEmpty
     * @param caseCheck - witch case to run the validation
     */
    runValidation(value:string, extraData:IExtraData = {}, isCheckValue = true, caseCheck = 'REGEX') {
        switch (caseCheck) {
            case 'REGEX':
                return this.runValidationWithRegex(value, isCheckValue, extraData);
            default:
                return true;
        }
    }
}

export const textInputValidation = new TextInputValidation();
